import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PNSAuthService} from '@portal-ng/PNSServices/PNSAuth.service';
import {Store} from '@ngrx/store';
import {IState} from '@portal-ng/PNSUser/reducers';
import {SAMLTokenRequest} from '@portal-ng/PNSAuth/actions/PNSAuth.actions';
import {SAMLTokenRequestPayload} from '@portal-ng/PNSModels';
import {environment} from '../../../../environments/environment';

@Component({
  selector   : 'portal-ng-authorize',
  templateUrl: './authorize.component.html',
  styleUrls  : ['./authorize.component.scss']
})
export class AuthorizeComponent implements OnInit {

  showLoginButton = false;

  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private auth: PNSAuthService,
      private store: Store<IState>,
  ) { }

  ngOnInit(): void {
    if (this.route.snapshot.queryParams['code'] === undefined || this.route.snapshot.queryParams['code'] === null) {
      this.router.navigate(['/login']);
    } else if (window.location.href !== undefined) {
      this.store.dispatch(new SAMLTokenRequest( {
        code       : this.route.snapshot.queryParams['code'],
        redirectURL: environment.Portal.defaultLoggedInRoute,
      } as SAMLTokenRequestPayload));
    } else {
      console.log('SAMLLogin Component Error');
    }
  }
}

